import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {MatSelectModule} from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';


import { MatSortModule } from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { NgxFileDropModule } from 'ngx-file-drop';

//// FUSE
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseDemoModule } from '@fuse/components/demo/demo.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
// SWEETALERT
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

/// COMPONENTES
import { WizardN35encuestadorComponent } from './wizard-n35encuestador.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';

//import {Adicionalesn35Component} from '../pagina/encuestador-n35/adicionalesn35/adicionalesn35.component';
//COLABORADORES
import { Colabs35Component } from '../pagina/encuestador-n35/colabs35/colabs35.component';

//PROGRAMACION
import { SheduleComponent } from '../pagina/certificar/shedulesurvey/shedule.component'; // Verificar
import { Shedulesurvey35Component } from '../pagina/encuestador-n35/shedulesurvey35/shedulesurvey35.component';


//ENVIO
import { Dispatch35Component } from '../pagina/encuestador-n35/dispatch35/dispatch35.component';


//CLOSE
// import { CloseComponent } from '../pagina/certificar/close/close.component'; // Verificar

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

import { Formadialog35Component} from 'app/main/pagina/encuestador-n35/shedulesurvey35/formadialog35/formadialog35.component';

import { WorkflowComponent} from '../pagina/certificarN35/workflow/workflow.component';
import {TasklistComponent} from '../pagina/certificarN35/tasklist/tasklist.component';

//import { Demographictabs35Component } from '../pagina/encuestador-n35/demographictabs35/demographictabs35.component';
import { Close35Component } from '../pagina/encuestador-n35/close35/close35.component';
import {Encuestas35Component} from '../pagina/encuestador-n35/encuestas35/encuestas35.component';
import { Colaboradores35Component } from '../pagina/encuestador-n35/colaboradores35/colaboradores35.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { CreacionComponent } from 'app/main/pagina/productos/nom35/v3/crear-encuesta/creacion.component';
import { CreacionModule } from 'app/main/pagina/productos/nom35/v3/crear-encuesta/creacion.module';
import { ProgramacionComponent } from 'app/main/pagina/productos/nom35/v3/programacion/programacion.component';
import { ProgramacionModule } from 'app/main/pagina/productos/nom35/v3/programacion/programacion.module';
import { DispatchComponent } from 'app/main/pagina/productos/nom35/v3/dispatch/dispatch.component';
import { EstatusEncuestaComponent } from 'app/main/pagina/productos/nom35/v3/estatus-encuesta/estatus-encuesta.component';
import { DispatchModule } from 'app/main/pagina/productos/nom35/v3/dispatch/dispatch.module';
import { ProjectDashboardComponent,FechasRecordatoriosComponent } from 'app/main/pagina/productos/nom35/v3/cierre/cierre.component';
// import { ProjectDashboardModule } from 'app/main/pagina/productos/nom35/v3/cierre/cierre.module';
const rutas: Routes = [
  {
    path     : 'NOM35-ENC/wizard-enc',
    component: WizardN35encuestadorComponent,
    data : {producto : 'Nom1'},
    children: [
        { path: '', redirectTo: 'collaborator', pathMatch: 'full'  },
        // Temporales
       // { path: 'main-page', component: Demographictabs35Component, canActivate: [AuthGuard]},
        { path: 'collaborators', component: Colaboradores35Component, canActivate: [AuthGuard] },
        { path: 'mailSending-nom035', component: Dispatch35Component, canActivate: [AuthGuard] },
        { path: 'collaborators35', component: Colabs35Component, canActivate: [AuthGuard] },
        //{ path: 'adicionales-35', component: Adicionalesn35Component, canActivate: [AuthGuard]},
        { path: 'cierre-n35', component: Close35Component, canActivate: [AuthGuard]},
        { path: 'work-flow', component: WorkflowComponent, canActivate: [AuthGuard]},
        { path: 'to-do-task', component: TasklistComponent, canActivate: [AuthGuard]},
        { path: 'schedule', component: Shedulesurvey35Component, canActivate: [AuthGuard] },
        { path: 'encuestas-col', component: Encuestas35Component, canActivate: [AuthGuard] },


    ]
  },
  {
    path     : 'NOM35-ENC/wizard-enc_t3',
    component: WizardN35encuestadorComponent,
    data : {producto : 'Nom3'},
    children: [
        { path: '', redirectTo: 'collaborator', pathMatch: 'full'  },
        // Temporales
       // { path: 'main-page', component: Demographictabs35Component, canActivate: [AuthGuard]},
        { path: 'collaborators', component: Colaboradores35Component, canActivate: [AuthGuard] },
        { path: 'crearencuesta', component: CreacionComponent, canActivate: [AuthGuard] },
        { path: 'mailSending-nom035', component: DispatchComponent, canActivate: [AuthGuard] },
        { path: 'collaborators35', component: Colabs35Component, canActivate: [AuthGuard] },
        //{ path: 'adicionales-35', component: Adicionalesn35Component, canActivate: [AuthGuard]},
        // { path: 'cierre-n35', component: Close35Component, canActivate: [AuthGuard]},
        { path: 'work-flow', component: WorkflowComponent, canActivate: [AuthGuard]},
        { path: 'to-do-task', component: TasklistComponent, canActivate: [AuthGuard]},
        // { path: 'schedule', component: Shedulesurvey35Component, canActivate: [AuthGuard] },
        { path: 'encuestas-col', component: Encuestas35Component, canActivate: [AuthGuard] },
        { path: 'schedule', component: ProgramacionComponent, canActivate: [AuthGuard] },
        { path: 'statusSurveys', component: EstatusEncuestaComponent, canActivate: [AuthGuard] },
        { path: 'cierre-n35', component: ProjectDashboardComponent, canActivate: [AuthGuard]},


    ]
  },
];

@NgModule({
  declarations: [

    Formadialog35Component,
    DispatchComponent,
    EstatusEncuestaComponent,
    ProjectDashboardComponent,
    FechasRecordatoriosComponent,



  ],
  imports     : [
      RouterModule.forChild(rutas),
      MatBadgeModule,
      MatButtonModule,
      MatCheckboxModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatMenuModule,
      MatRippleModule,
      MatSelectModule,
      MatSnackBarModule,
      MatTableModule,
      MatToolbarModule,
      MatTabsModule,
      MatRadioModule,
      MatProgressBarModule,
      BrowserModule,
      BrowserAnimationsModule,
      DragDropModule,
      MatButtonToggleModule,
      MatCardModule,
      FuseSidebarModule,
      FuseSharedModule,
      FuseDemoModule,
      SweetAlert2Module,
      TranslateModule,
      NgxMaterialTimepickerModule,
      CreacionModule,
      ProgramacionModule,
      DispatchModule,

  ],
  entryComponents: [

    Formadialog35Component,
    FechasRecordatoriosComponent,


  ]
})
export class WizardN35EncuestadorRutasModule {
    //const routes = this.rutas;
}
